import React from 'react';
import { FilterSwipeDialog } from '../../../components/dialog/FilterSwipeDialog';
import './MenuPopUpOffersFilter.css';

export default function MenuPopUpOffersFilter({ 
    children, 
    appliedCount = 0, 
    onClearAll, 
    onClickProfile, 
    profileLabel = 'Mon profil', 
    profileDisabled = false, 
    profileLoading = false 
}) {
    return (
        <div className="oc-mobile-filters">
            <FilterSwipeDialog
                isLoading={profileLoading}
                onClearFilters={onClearAll}
                className="oc-filters-dialog-mobile"
            >
                {children}
            </FilterSwipeDialog>
        </div>
    );
};
